// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/impact/impact.component.css
// module id = 753
// module chunks = 0